<lex-sidenav-container>
  <ng-container left>
    <div></div>
    <!--Account Search-->
    <div style="margin-top: 8px; font-size: 15px; height: 75px; align-items: center">
      <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; place-content: stretch space-between; align-items: stretch; gap: 20px;">
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row">
          <div mat-line style="width: 100%; display: flex;">
            <button mat-mini-fab color="primary" id="openAddAccountDialog" *inRole="[roles.GlobalAccountAdvancedFeatureSet, roles.Operations]" class="add-account-button" (click)="addAccount()" matTooltip="Create new account">
              <mat-icon>add</mat-icon>
            </button>
            <mat-form-field style="margin-left: 15px; margin-right: 15px; width:100%">
              <input matInput placeholder="Search Accounts" #searchBox id="search-box" (keyup)="updateSearchText(searchBox.value)" [(ngModel)]="searchText" />
              <button id="clearSearch" *ngIf="searchBox.value" matSuffix mat-icon-button aria-label="Clear" (click)="searchBox.value=''; updateSearchText(searchBox.value)">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <cdk-virtual-scroll-viewport #leftScroll itemSize="48" style="height:87%">
      <mat-action-list style="overflow: hidden;" *ngIf="accounts$ | async as accounts">

        <!--Account List-->
        <button mat-list-item [attr.id]="'selectAccountId.'+account.accountId" *cdkVirtualFor="let account of accounts" [ngClass]="{'sidenav-selected-item': selectedAccount === account, 'sidenav-row-item': selectedAccount !== account}" (click)="selectAccount(account)">
          <div matListItemTitle> {{account.accountName}} </div>
          <mat-divider></mat-divider>
        </button>

      </mat-action-list>
    </cdk-virtual-scroll-viewport>

    <div></div>
  </ng-container>

  <!--Accounts Main Layout main content-->
  <ng-container right>
    <div style="flex-direction: column; box-sizing: border-box; display: flex; place-content: stretch space-between; align-items: stretch; flex: 1 1 0%; gap: 20px;" *ngIf="!selectedAccount">
      <div></div>
      <div style="flex-direction: row; box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px;">
        <div></div>
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column" *ngIf="accounts$ | async as accounts">
          <mat-toolbar color="primary" class="toolbar-over-card">
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-start; align-items: center;">
              <mat-card-title>Total Accounts: {{accounts.length}}</mat-card-title>
            </div>
          </mat-toolbar>
          <div style="flex: 1 1 0%; box-sizing: border-box;">
            <mat-card appearance="outlined">
              <div style="font-size: 15px">
                No Account Selected
              </div>
            </mat-card>
          </div>
        </div>
        <div></div>
      </div>
      <div></div>
    </div>
    <lex-account-edit *ngIf="selectedAccount" style="flex: 1 1 0%; box-sizing: border-box;" [selectedAccountId]="selectedAccount.accountId" [searchTerm]="searchText"></lex-account-edit>
  </ng-container>
</lex-sidenav-container>
